import { GraphQLEnumType } from 'graphql';

const SubmissionAnswerEnum = {
  VIDEO: 'VIDEO',
  AUDIO: 'AUDIO',
  TEXT: 'TEXT',
  IMAGE: 'IMAGE',
  SINGLE_SELECT: 'SINGLE_SELECT',
  MULTIPLE_SELECT: 'MULTIPLE_SELECT',
  EMPTY: 'EMPTY',
  MATCH_THE_FOLLOWING: 'MATCH_THE_FOLLOWING',
  FILL_IN_THE_BLANKS: 'FILL_IN_THE_BLANKS',
  OPINION_SCALE: 'OPINION_SCALE',
  FILE: 'FILE'
};

module.exports = new GraphQLEnumType({
  name: 'ResponseType',
  values: {
    VIDEO: {
      value: SubmissionAnswerEnum.VIDEO
    },
    AUDIO: {
      value: SubmissionAnswerEnum.AUDIO
    },
    TEXT: {
      value: SubmissionAnswerEnum.TEXT
    },
    IMAGE: {
      value: SubmissionAnswerEnum.IMAGE
    },
    SINGLE_SELECT: {
      value: SubmissionAnswerEnum.SINGLE_SELECT
    },
    MULTIPLE_SELECT: {
      value: SubmissionAnswerEnum.MULTIPLE_SELECT
    },
    EMPTY: {
      value: SubmissionAnswerEnum.EMPTY
    },
    MATCH_THE_FOLLOWING: {
      value: SubmissionAnswerEnum.MATCH_THE_FOLLOWING
    },
    FILL_IN_THE_BLANKS: {
      value: SubmissionAnswerEnum.FILL_IN_THE_BLANKS
    },
    OPINION_SCALE: {
      value: SubmissionAnswerEnum.OPINION_SCALE
    },
    FILE: {
      value: SubmissionAnswerEnum.FILE
    }
  }
});
